export const parseFloatInput = (value) => {
    let preProcessedValue;
    if (value.replace) {
        preProcessedValue = value.replace(',', '.');
    } else {
        preProcessedValue = value;
    }
    return parseFloat(preProcessedValue);
};

export const mapObject = (src, convertFunc) => {
    if (!src) {
        return src;
    }
    return Object.entries(src).reduce((target, [itemKey, itemValue]) => {
        return { ...target, [itemKey]: convertFunc(itemValue, itemKey) };
    }, {});
};
